module.exports = __webpack_public_path__ + "static/assets/4b74f619cb959e9ca7d72de2c1797a54.png";